<template>
  <div
    class="spnod-admin__form--container container mx-0 w-100"
    :class="isMobile ? 'px-0' : 'px-3'">
    <b-form v-if="getMyInfo._id" id="form" @submit.stop.prevent="handleSubmit">
      <b-form-row class="d-flex align-items-center">
        <b-form-checkbox
          class="checkbox d-flex align-items-center pr-1 py-0"
          id="client"
          v-model="form.isClient"
        >
          Member
        </b-form-checkbox>
        <div>
          <b-icon-question-circle-fill
            v-if="!isTablet"
            class="icon"
            variant="secondary"
            v-b-tooltip.hover.right.v-secondary="copy.athlete"
          />
          <b-icon-question-circle-fill
            v-else
            class="icon"
            variant="secondary"
            v-b-tooltip.click.right.v-secondary="copy.athlete"
          />
        </div>
      </b-form-row>
      <b-form-row class="d-flex align-items-center">
        <b-form-checkbox
          id="parentGuardian"
          v-model="form.parentGuardian"
          class="checkbox d-flex align-items-center pr-1 py-0"
        >
          Parent / Guardian
        </b-form-checkbox>
        <div>
          <b-icon-question-circle-fill
            v-if="!isTablet"
            class="icon"
            variant="secondary"
            v-b-tooltip.hover.right.v-secondary="copy.parentGuardian"
          />
          <b-icon-question-circle-fill
            v-else
            class="icon"
            variant="secondary"
            v-b-tooltip.click.right.v-secondary="copy.parentGuardian"
          />
        </div>
      </b-form-row>
      <b-form-row class="d-flex align-items-center">
        <b-form-checkbox
          id="coach"
          v-model="form.isCoach"
          class="checkbox d-flex align-items-center pr-1 py-0"
        >
          Coach
        </b-form-checkbox>
        <div>
          <b-icon-question-circle-fill
            v-if="!isTablet"
            class="icon"
            variant="secondary"
            v-b-tooltip.hover.right.v-secondary="copy.coach"
          />
          <b-icon-question-circle-fill
            v-else
            class="icon"
            variant="secondary"
            v-b-tooltip.click.right.v-secondary="copy.coach"
          />
        </div>
      </b-form-row>
      <b-form-group class="d-flex justify-content-end">
        <b-button v-if="form.isClient || form.parentGuardian || form.isCoach" class="spnod-admin__form--button" type="submit" size="sm">Send</b-button>
        <b-button v-if="!form.isClient && !form.parentGuardian && !form.isCoach" disabled class="spnod-admin__form--button" type="submit" size="sm">Send</b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RoleForm',
  data() {
    return {
      form: {
        isClient: false,
        parentGuardian: false,
        isCoach: false
      },
      copy: {}
    }
  },
  computed: {
    ...mapGetters(['getMyInfo']),
    isMobile() { return window.innerWidth <= 768 },
    isTablet() { return window.innerWidth <= 1200 }
  },
  methods: {
    ...mapActions(['updateRoles', 'getUserFromLocalStorage', 'getMe', 'getCopy']),
    handleSubmit: async function () {
      if (!this.form.isClient && !this.form.parentGuardian && !this.form.isCoach) {
        this.form.isClient = true
      }
      await this.updateRoles({ form: this.form, id: this.getMyInfo._id })
      if (this.form.isClient) {
        this.$router.push('/payment')
      } else {
        this.$router.push('/user')
      }
    }
  },
  mounted: async function () {
    this.copy = await this.getCopy()
    await this.getUserFromLocalStorage('user')
  }
}
</script>

<style scoped>
input[type='checkbox'] {
  margin-top: -5px;
}

.icon {
  height: 15px;
  width: 15px;
}
</style>



// WEBPACK FOOTER //
// src/app/components/Forms/RoleForm.vue?7cc12727